import { createRouter, createWebHistory } from 'vue-router';

import lib from '@/lib';

import Layout from '@/layouts/Layout';

import Login from '@/pages/Login';
import Main from '@/pages/Main';
import Instructions from '@/pages/Instructions';
import Game from '@/pages/Game';
import Results from '@/pages/Results';

import Test from '@/pages/Test';

import PageNotFound from '@/pages/PageNotFound';

const routes = [
	{
		path: '/',
		component: Layout,
		children: [
			{
				path: '/',
				component: Main,
			},
			{
				path: '/login',
				component: Login,
				meta: {
					guest: true,
				},
			},
			{
				path: '/instructions',
				component: Instructions,
			},
			{
				path: '/game',
				component: Game,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/results',
				component: Results,
			},
		],
	},
	{
		path: '/test',
		component: Test,
	},
	{
		path: '/logout',
		beforeEnter(to, from, next){
			storeInstance.state.app.auth.doLogout().then(() => {
				next({path: '/'});
			});
		},
	},
	{
		path: '/:pathMatch(.*)*',
		component: Layout,
		children: [
			{
				path: '',
				component: PageNotFound,
			},
		],
	},
	{
		path: '/:pathMatch(.*)',
		component: Layout,
		children: [
			{
				path: '',
				component: PageNotFound,
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	storeInstance.state.app.auth.doInitData().then(() => {
		if(to.matched.some(record => record.meta.requiresAuth)){
			if(!storeInstance.state.app.auth.isAuth()){
				next({
					path: '/login',
					//path: '/',
					params: {
						nextUrl: to.fullPath,
					},
				})
			} else {
				if(to.matched.some(record => record.meta.is_admin)){
					if(storeInstance.state.app.auth.isAdmin()){
						next()
					} else {
						next('/')
					}
				} else {
					next()
				}
			}
		} else if(to.matched.some(record => record.meta.guest)){
			if(storeInstance.state.app.auth.isAuth()){
				next('/')
			} else {
				next()
			}
		} else {
			next() 
		}
	});
});
/*// Не позволяет авторизованному пользователю перейти на страницу логина и перекидывает его на главную страницу
router.beforeEach((to, from, next) => {
	if (to.path == '/login' && storeInstance.state.app.auth.isAuth()) next({path: '/'})
  	else next()
})*/

export default router;